// @ts-nocheck
import { background_list, icon_list } from '@/assets/images'
import { StyledButton } from '@/components/atoms'
import Image from 'next/image'
import { useTranslation } from 'react-i18next';

const ExpiredPaymentStatus = () => {
	const { t } = useTranslation('product')
  
  return (
    <div className='w-full'>
      <div className='tw-p-5 tw-bg-white tw-border tw-border-light-green tw-rounded-md tw-mb-5 tw-flex tw-flex-col tw-items-center'>
        <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-red-600 tw-to-red-400 tw-font-bold md:tw-text-3xl tw-text-xl tw-mb-5 tw-text-center'>
          {t('product.payment_exp')}
        </h1>
        <Image src={background_list.expired_payment} alt='' />
        <span className='tw-text-center tw-font-semibold tw-mb-8 md:tw-text-[15px] tw-text-xs'>
          {t('product.payment_exp_desc')}
        </span>

        <div className='tw-bg-white tw-p-4 tw-rounded-lg tw-border tw-border-light-green tw-mb-5 tw-mt-10 tw-w-full'>
          <div className='tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-relative tw-font-semibold md:tw-text-[15px] tw-text-xs'>
            <div className='tw-flex tw-justify-between tw-w-full'>
              <button className='tw-flex tw-flex-row tw-items-center tw-gap-2'>
                <span>[invoice_id] </span>
                <Image src={icon_list.copy_green} alt='' />
              </button>
              <button className='tw-underline tw-text-dark-green tw-font-semibold'>{t('product.see_invoice')}</button>
            </div>
            <div className='tw-flex tw-justify-between tw-w-full'>
              <span>{t('product.purchase_date')}</span>
              <span className='tw-text-right'>10 August 2023, 15:29 WIB</span>
            </div>
          </div>
        </div>

        <div className='tw-bg-white tw-p-4 tw-rounded-lg tw-border tw-border-light-green tw-mb-5 tw-w-full'>
          <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-2xl tw-text-xl'>{t('product.detail_package')}</h1>
          <div className='tw-flex tw-flex-col tw-gap-5'>
            <div className='tw-bg-white tw-p-4 tw-rounded-lg '>
              <div className='tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3'>
                <div className='tw-flex tw-h-full tw-w-full tw-flex-col'>
                  <h2 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-lg tw-font-semibold'>SMM - Starter Package</h2>
                  <ol className='tw-mt-2 tw-pl-7 tw-list-disc'>
                    <li>sadasdasd</li>
                    <li>sadasdasd</li>
                    <li>sadasdasd</li>
                    <li>sadasdasd</li>
                  </ol>
                </div>
              </div>
            </div>
            <div className='tw-w-full tw-pt-5 tw-border-t-[1px] tw-border-light-green tw-mt-5 tw-flex tw-justify-between tw-px-3'>
              <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-2xl tw-text-sm'>{t('product.price')} {t('product.total_desc')}</h1>
              <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-2xl tw-text-sm'>IDR 12323223</h1>
            </div>
          </div>
        </div>

        <div className='tw-bg-white tw-p-4 tw-rounded-lg tw-border tw-border-light-green tw-mb-5 tw-w-full'>
          <div className='tw-flex tw-flex-col tw-gap-5'>
            <div className='tw-bg-white tw-rounded-lg '>
              <h2 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-lg tw-font-semibold tw-mb-3'>{t('product.payment_detail')}</h2>
              <div className='tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-3 md:tw-text-[15px] tw-text-xs'>
                <div className='tw-flex tw-justify-between'>
                  <span>{t('product.payment_method')}</span>
                  <span>Bank transfer</span>
                </div>
                <div className='tw-flex tw-justify-between'>
                  <span>Total Price ( x [total_item] )</span>
                  <span>[total_price]</span>
                </div>
                <div className='tw-flex tw-justify-between'>
                  <span>Tax</span>
                  <span>[tax_amount]</span>
                </div>
              </div>
            </div>
            <div className='tw-w-full tw-pt-3 tw-border-t-[1px] tw-border-light-green tw-mt-5 tw-flex tw-justify-between tw-px-3'>
              <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-2xl tw-text-sm'>{t('product.total_paid')}</h1>
              <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-font-bold md:tw-text-2xl tw-text-sm'>[total_paid]</h1>
            </div>
          </div>
        </div>
      </div>
      <div className='tw-w-full tw-flex tw-items-center tw-justify-center tw-mb-5 tw-mt-10'>
        <span className='tw-text-center tw-font-semibold tw-mb-8 md:tw-text-[15px] tw-text-xs'>{t('product.buy_again')}</span>
      </div>
      <div className='tw-flex tw-flex-1 tw-justify-center md:tw-flex-row tw-flex-col'>
        <StyledButton
          title={t('product.buy_again_button')}
          className='btn-dark-to-light-green-gradient tw-text-white tw-font-semibold md:tw-text-xl tw-text-md tw-items-center md:tw-px-12 tw-px-3 tw-py-2 tw-rounded-full md:tw-flex '
          onClick={() => console.log('WKWKKW')}
        />
      </div>
    </div>
  );
};


export default ExpiredPaymentStatus
